import React from "react";
import StepPlaceholder from "./StepPlaceholder";

interface StepProps {
  onBack: () => void;
  onFinish: () => void;
}

const Step5ReviewStart: React.FC<StepProps> = ({
  onBack,
  onFinish,
}) => {
  return (
    <StepPlaceholder
      step={5}
      label={
        <>
          Review & <span className="d-block">Start Test</span>
        </>
      }
      onBack={onBack}
      onNext={onFinish}
      isLast
    />
  );
};

export default Step5ReviewStart;